<template>
    <div class="content banner">
        <swiper ref="mySwiper" id="swiper1" :options="swiperOptions">
            <swiper-slide v-for="(items, index) in banners" :key="index">
                <a :href="items.linkUrl" target="_blank">
                    <img :src="items.linkImg" alt="" />
                </a>
            </swiper-slide>
        </swiper>
        <div class="swiper-pagination1"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
    </div>
</template>

<script>
export default {
    name: 'Banner',
    props: {
        banners: {
            type: Array,
            default: () => [],
        },
    },
    data: function () {
        return {
            swiperOptions: {
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination1',
                },
            },
        }
    },
}
</script>

<style lang="scss">
.banner {
    width: 100%;
    height: 100%;
    position: relative;
    img {
        width: 100%;
        height: calc(100vh - 88px);
    }
    .test {
        width: 100px;
        height: 100px;
        top: 0;
        left: 0;
        border-radius: 50%;
        background: #999;
        opacity: 0.5;
        color: #fff;
        z-index: 11011;
        position: absolute;
    }
}
</style>
